// Utah State University's bachelor's majors (#2740). Read on 2026-10-01 from
// the official USU Catalog 2026-2027 (catalog.usu.edu, a Coursedog catalog),
// through its own program search: every active undergraduate program with a
// bachelor's degree designation. Emphases, options and areas within a major
// ("Art: Ceramics", "Agribusiness - Agricultural Finance Emphasis") are folded
// into the major; a major offered as BA or BS is listed once per degree.
// Pre-major tracks, RN to BSN, online second-bachelor's and teacher-training
// programs, associate degrees, minors, certificates and graduate programs are
// left out. The search gives no college, so this is one A to Z group.
const majors = {
    "slug": "utah-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in USU's official 2026-2027 Catalog, with the degree it leads to. Emphases, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor's majors",
            "source": {
                "label": "USU Catalog 2026-2027, Programs",
                "url": "https://catalog.usu.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.A."
                },
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Agribusiness",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Education",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Systems Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Systems Technology and Agribusiness (Composite)",
                    "degree": "B.S."
                },
                {
                    "name": "Animal and Dairy Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.S."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Aviation Technology - Aviation Management",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation Technology - Maintenance Management",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation Technology - Professional Pilot",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Science: Composite Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Business Education",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Climate Science",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Conservation and Restoration Ecology",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood/Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Earth Science Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Energy Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Technology",
                    "degree": "B.A.S."
                },
                {
                    "name": "English",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Planning",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Equine Science and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Family and Consumer Sciences Education",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Fisheries and Aquatic Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forest Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Freshwater and Marine Ecology",
                    "degree": "B.S."
                },
                {
                    "name": "General Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Global Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Health Science",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.S."
                },
                {
                    "name": "Horticulture",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Human Experience Design and Interaction",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Interior Architecture and Design",
                    "degree": "B.I.A.D."
                },
                {
                    "name": "International Business",
                    "degree": "B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.S."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.L.A."
                },
                {
                    "name": "Law and Constitutional Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management and Restoration of Aquatic Ecosystems",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics/Statistics (Composite)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics/Statistics Education (Composite)",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Natural Resource Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition Science",
                    "degree": "B.S."
                },
                {
                    "name": "Outdoor Product Design and Development",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physical Science Composite Teaching (Chemistry)",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Science Composite Teaching (Physics)",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Planning & Design Technologies",
                    "degree": "B.S."
                },
                {
                    "name": "Plant Science",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.S."
                },
                {
                    "name": "Professional Sales",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Public Relations, Social Media and Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Public Relations, Social Media and Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Ranch Management Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Rangeland Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Recreation Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Recreation Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Residential Landscape Design and Construction",
                    "degree": "B.S."
                },
                {
                    "name": "Robotics, Automation, and Control Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Secondary Science Composite Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Social Studies (Composite Teaching)",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Soils and Sustainable Land Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.A."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                },
                {
                    "name": "Speech and Hearing Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Technical Communication and Rhetoric",
                    "degree": "B.S."
                },
                {
                    "name": "Technology Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Technology and Engineering Education",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Veterinary Science",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
